import { CaseAttachment, DamagePartDto, DamagePartPhotoDto } from '../../../../interfaces/Case';

const toFile = (photo: DamagePartPhotoDto): File => new File([], photo.originalFileName);

const toCaseAttachment = (photo: DamagePartPhotoDto, caseId: number): CaseAttachment => ({
  id: photo.id,
  caseId,
  attachmentTypeId: photo.attachmentType?.id ?? 0,
  attachmentType: photo.attachmentType,
  fileName: photo.fileName,
  uploadDate: new Date(photo.uploadDate),
  carPhotos: false,
  originalFileName: photo.originalFileName,
  file: toFile(photo),
  url: photo.url ?? undefined,
  caseRequestId: null,
  paymentId: null,
  serviceAppointmentId: null,
  caseClientId: null,
  isSelection: true,
  attachmentCategoryId: photo.attachmentCategory?.id ?? null,
  attachmentCategory: photo.attachmentCategory,
  damagePartId: photo.damagePartId,
  damagePart: null,
  distanceTypeId: photo.distanceType?.id ?? null,
  distanceType: photo.distanceType,
  attachmentStatusId: photo.attachmentStatus?.id ?? null,
  attachmentStatus: photo.attachmentStatus
});

export const toCaseAttachments = (parts: DamagePartDto[]): Record<number, CaseAttachment> =>
  parts.reduce(
    (attachments, part) =>
      part.photos.reduce(
        (partAttachments, photo) => ({
          ...partAttachments,
          [photo.id]: toCaseAttachment(photo, part.caseId)
        }),
        attachments
      ),
    {} as Record<number, CaseAttachment>
  );

export enum DistanceTypeCode {
  FAR = 'FAR',
  CLOSE = 'CLOSE'
}
